import { useEffect, useState } from "react";
import UseInView from "./UseInView/UseInView";

export default function AnimatedNumber({ target }) {
  const [ref, isVisible] = UseInView();
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!isVisible) return;

    const duration = 1500;
    const frameRate = 30; // atualiza ~30 vezes por segundo
    const totalSteps = Math.floor((duration / 1000) * frameRate);
    const increment = Math.ceil(target / totalSteps);

    let current = 0;

    const interval = setInterval(() => {
      current += increment;
      if (current >= target) {
        current = target;
        clearInterval(interval);
      }
      setValue(current);
    }, 1000 / frameRate);

    return () => clearInterval(interval);
  }, [isVisible, target]);

  return (
    <div ref={ref} className="text-4xl font-bold text-white">
      {value}
    </div>
  );
}
